module.exports = __webpack_public_path__ + "static/media/push-icon.e1cde502.svg";